import type { ProtoProfile } from '@ducat-unit/core';
import type { DefaultError, UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { NetworkSettingsConfig } from '@/config/config.types';

import { fetchProtoProfile } from '../api/fetchers/protocol-profile';
import { QueryKeys } from '../api/query-keys';

type QueryOptionsParam = Omit<UseQueryOptions<ProtoProfile, DefaultError>, 'queryKey' | 'queryFn'>;

export function useContractProfile(config: NetworkSettingsConfig | undefined, options?: QueryOptionsParam) {
  const queryKey = [QueryKeys.contractProfile, config?.network];

  return useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      if (!config) {
        throw Error('Network config not ready yet.');
      }
      return fetchProtoProfile(config, signal);
    },
    enabled: !!config?.network,
    staleTime: Infinity,
    retry: 1,
    retryDelay: 500,
    networkMode: 'always',
    ...options,
  });
}
